import { render, staticRenderFns } from "./VueNavigationItem.vue?vue&type=template&id=70ef3c15&"
import script from "./VueNavigationItem.vue?vue&type=script&lang=js&"
export * from "./VueNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports